import { ONBOARDING_SIGNALS_CONFIRM_ID } from "testIds";
import Flex from "common/Boxes/Flex";
import {
  CONFIRM_AUTO_TRADING_MESSAGE,
  UNCHECKED_CHECKBOX_MESSAGE,
} from "@shared/features/onboarding/constants";
import { OnboardingStyles } from "features/onboarding/common/styles";
import React from "react";
import styled from "styled-components";
import Checkbox from "common/Checkbox/Checkbox";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface ConfirmCheckboxProps {
  setIsChecked: (isChecked: boolean) => void;
  showCheckboxError: boolean;
  setShowCheckboxError: (showCheckboxError: boolean) => void;
}

const ConfirmCheckbox = ({
  setIsChecked,
  showCheckboxError,
  setShowCheckboxError,
}: ConfirmCheckboxProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  const onCheckboxChanged = (checked: boolean) => {
    setIsChecked(checked);
    if (checked) setShowCheckboxError(false);
  };

  return (
    <>
      <Flex
        $justifyContent="flex-start"
        $alignItems="flex-start"
        style={{ marginTop: 24 }}
      >
        <StyledCheckbox
          data-testid={ONBOARDING_SIGNALS_CONFIRM_ID}
          onChange={(event) => onCheckboxChanged(event.target.checked)}
        >
          <OnboardingStyles.ConfirmMessage>
            {t(CONFIRM_AUTO_TRADING_MESSAGE)}
          </OnboardingStyles.ConfirmMessage>
        </StyledCheckbox>
      </Flex>
      {showCheckboxError && (
        <OnboardingStyles.ErrorText $isMobile={isMobile}>
          {t(UNCHECKED_CHECKBOX_MESSAGE)}
        </OnboardingStyles.ErrorText>
      )}
    </>
  );
};

export default ConfirmCheckbox;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-right: 0;
  }
  .ant-checkbox {
    align-self: flex-start;
    transform: translateY(5px);
  }
`;
